import styled, { css } from 'styled-components';
import { Button } from 'style/buttons';

export const SearchButton = styled(Button)`
    height: 28px;
    padding: 5px;
    font-size: 12px;
`;